import React, { useContext, useEffect, useMemo, useReducer, useState } from 'react';
import { Segment } from 'semantic-ui-react';
import { uniqueKey } from '../../../../global/common/keys';
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext';
import { sidebarHandlers, sidebarInitialState, sidebarMenuTypes, sidebarReducer, sidebarSliderTypes } from '../../../../global/cnr/reducers/SidebarReducer';
import MenuSidebars from '../../../../global/sidebars/MenuSidebars';
import SeasonMatchesProvider from '../../cnr/contexts/SeasonMatchesContext';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import MatchListSelected from '../../elements/matches/MatchListSelected';
import PlayoffBracket, { playoffBracketTypes } from '../../elements/matches/PlayoffBracket';
import { CreateSportsContext } from '../CreateSports';
import NoData from '../../../../global/components/alerts/NoData';
import PlayoffBrackets from '../../elements/matches/PlayoffBrackets';
import { CreatePlayoffContext } from '../CreatePlayoff';
import { tournamentTypes } from '../../cnr/reducers/SportsTournamentReducer';
import { createScheduleTypes } from 'projectSpecific/sports/cnr/reducers/CreateSportsReducer';
import { useSportsTournaments } from 'projectSpecific/sports/useHelpers/useSeasonals';
import { useTournamentData } from 'projectSpecific/sports/useHelpers/useTournamentData';

const sidebarType = 'createTournament'

/**
 * 
 * @param {object} props 
 * @returns 
 */
const CreateTournamentSchedule = (props) => {

  const { createScheduleType, tournamentType, componentContexts, asGrid, tournament: pageTournament } = props ?? {}

  // parentContext
  const parentContext = useContext(ParentContext);
  const { fns } = parentContext ?? {}
  const { navigation_fns } = fns

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}
  const { playoff_info: playoff_info_season, inverted, _sportSeasonSettings } = sportsSeason_state ?? {}
  const { usePlayoffBrackets } = _sportSeasonSettings ?? {}
  const { playoffTournaments } = playoff_info_season ?? {}

  // createSportsContext and createPlayoffContext are in the same tree
  // createSportsContext
  const createSportsContext = useContext(CreateSportsContext);
  const { createSports_state } = createSportsContext ?? {}
  const { playoff_info: playoff_info_create } = createSports_state ?? {}

  // createPlayoffContext
  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state, createPlayoff_handlers } = createPlayoffContext ?? {}
  const { playoff_matchInfo, playoff_info: playoff_info_playoff, playoffGroupKey } = createPlayoff_state ?? {}
  const { tournaments: tournaments_playoff } = playoff_matchInfo ?? {}

  const playoffInfo = playoff_info_playoff ? playoff_info_playoff : playoff_info_create
  const { playoffLevelTeams, playoffLevel, playoffTeamsSorted, plts } = playoffInfo ?? {}
  // const { playoffLevelTeams, playoffLevel, playoffTeamsSorted, plts } = _playoff_matchInfo ?? {}

  const _plts = plts?.[playoffGroupKey]

  // sidebar
  const [sidebar_state, sidebar_dispatch] = useReducer(sidebarReducer, sidebarInitialState({ sidebarType, handlers: sportsSeason_handlers }));
  const sidebar_handlers = sidebarHandlers(sidebar_dispatch)
  const { sidebar_items, currents, dimmed } = sidebar_state ?? {}
  const { setInit, setInits } = sidebar_handlers ?? {}

  // ms_rounds playoffs etc.
  // ms_tournaments 4A, 3A, etc.
  // ms_pools R16, QF, SF, F

  const { ms_tournaments, ms_pools } = sidebar_items ?? {}
  let { ms_rounds } = sidebar_items ?? {}

  const { selected: selected_tournament } = ms_tournaments ?? {}
  const { item: item_tournament } = selected_tournament ?? {}

  const tournament_current = item_tournament ? item_tournament : playoffLevel

  const { selected: selected_pool } = ms_pools ?? {}
  const { item: item_pool } = selected_pool ?? {}

  if (tournamentType === tournamentTypes.existingPlayoff) { ms_rounds = { selected: { item: 'playoffs' } } }

  const { selected: selected_round } = ms_rounds ?? {}
  const { item: item_round } = selected_round ?? {}

  const _initProps = { sidebarSliderType: sidebarSliderTypes.labeled }

  // componentContexts
  const { uiItemContext } = componentContexts ?? {}
  const { item_state } = uiItemContext ?? {}
  const { viewItem } = item_state ?? {}

  const { createTournamentInfo } = useTournamentData()

  // const sportTournamentHelpers = useSportsTournaments()

  // rounds - playoffs
  // tournaments - 4A, 3A, 2A, 1A
  // pools - R32, R16, QF, SF, F
  // schedule - schedule, ?results 

  useEffect(() => {
    if (tournamentType === tournamentTypes.newPlayoff) {
      const cb = (tournaments, playoffMatches, tournamentMatches) => {
        console.log('tournaments, playoffMatches, tournamentMatches', tournaments, playoffMatches, tournamentMatches)
        //createPlayoff_handlers.handleAmmend_playoffMatchInfo
      }
      createTournamentInfo({ forPlayoff: true, state: createPlayoff_state, callback: createPlayoff_handlers.handleAmmend_playoffMatchInfo })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [_plts]);

  // sets the tournaments
  const tournaments = useMemo(() => {
    switch (tournamentType) {
      case tournamentTypes.tournament: {
        const { name: tournamentName } = pageTournament ?? {};
        return tournamentName ? { [tournamentName]: pageTournament } : {};
      }
      case tournamentTypes.newPlayoff:
        return tournaments_playoff;
      default:
        return playoffTournaments;
    }
  }, [tournamentType, pageTournament, tournaments_playoff, playoffTournaments]);

  const noData = !tournaments || Object.keys(tournaments).length === 0;

  const getInits_tournaments = (rounds, pools) => {
    let _ins = []
    switch (tournamentType) {
      case tournamentTypes.existingPlayoff:
        _ins = [{ smt: sidebarMenuTypes.one, items: Object.keys(tournaments).sort().reverse(), currents, as: 'tournaments', ..._initProps }]
        if (!usePlayoffBrackets) {
          _ins.push({ smt: sidebarMenuTypes.two, items: pools ? Object.values(pools) : [], currents, as: 'pools', useStartCase: true, ..._initProps })
        }
        break;
      default:
        _ins = [
          { smt: sidebarMenuTypes.one, items: rounds ? Object.keys(rounds) : [], currents, as: 'rounds', useStartCase: true, ..._initProps, hidden: true },
          { smt: sidebarMenuTypes.two, items: playoffLevel ? [] : Object.keys(tournaments).sort().reverse(), currents, as: 'tournaments', ..._initProps },
        ]
        if (!usePlayoffBrackets) {
          _ins.push({ smt: sidebarMenuTypes.three, items: pools ? Object.values(pools) : [], currents, as: 'pools', useStartCase: true, ..._initProps })
        }
    }
    return _ins
  }

  // gets the inits when tournaments have been set
  useEffect(() => {
    if (tournaments) {
      const { rounds, poolz } = getPoolsAndRounds()
      const _inits = getInits_tournaments(rounds, poolz)
      setInits(_inits)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [tournaments]);


  useEffect(() => {
    if (tournament_current && item_round) {
      const { poolz } = getPoolsAndRounds(tournament_current)
      switch (tournamentType) {
        case tournamentTypes.existingPlayoff:
          setInit({ smt: sidebarMenuTypes.two, items: poolz ? Object.values(poolz) : [], currents, as: 'pools', useStartCase: true, ..._initProps, hidden: usePlayoffBrackets })
          break;
        default:
          setInit({ smt: sidebarMenuTypes.three, items: poolz ? Object.values(poolz) : [], currents, as: 'pools', useStartCase: true, ..._initProps, hidden: usePlayoffBrackets })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [tournament_current, item_round]);

  const handleMatchClick = (clickedItem, itemKey, modifyMode, opts, ddn, ddProps, ddGroupIndex) => {
    if (itemKey) navigation_fns.handleNav_item(clickedItem, itemKey, modifyMode, opts, ddn, ddProps, ddGroupIndex)
  }

  // called from getPoolsAndRounds
  const getPoolz = (pools) => {
    const poolz = []
    if (pools && pools.roundOf32) { poolz.push(playoffBracketTypes.roundOf32) }
    if (pools && pools.roundOf16) { poolz.push(playoffBracketTypes.roundOf16) }
    if (pools && pools.quarterFinals) { poolz.push(playoffBracketTypes.quarterFinals) }
    if (pools && pools.semiFinals) { poolz.push(playoffBracketTypes.semiFinals) }
    if (pools && pools.finals) { poolz.push(playoffBracketTypes.finals) }
    return poolz
  }

  const getPoolsAndRounds = (tournamentItem) => {
    switch (tournamentType) {
      case tournamentTypes.existingPlayoff:
        const tournament = tournamentItem ? tournaments[tournamentItem] : Object.values(tournaments)[0]
        const { rounds: rounds_t } = tournament ?? {}
        const round_t = rounds_t && item_round ? rounds_t[item_round] : null
        const { pools: pools_t } = round_t ?? {}
        const poolz1 = getPoolz(pools_t)
        return { rounds: rounds_t, poolz: poolz1 }

      default:
        const t = tournamentItem ? tournaments[tournamentItem] : Object.values(tournaments)[0]
        const { rounds } = t ?? {}
        const round = rounds ? Object.values(rounds)[0] : {}
        const { pools } = round ?? {}
        const poolz2 = getPoolz(pools)
        return { rounds, poolz: poolz2 }
    }
  }

  const playoffBrackets = (round) => <PlayoffBrackets
    round={round}
    roundItem={ms_rounds.selected.item}
    componentContexts={componentContexts}
    tournamentType={tournamentType}
    asGrid={asGrid}
    item_tournament={tournament_current}
  />

  const selectedMatches = useMemo(() => {


    let allow = false
    switch (tournamentType) {
      case tournamentTypes.existingPlayoff:
        if (tournaments && ms_tournaments && ms_pools) {
          allow = true
        }
      default:
        if (tournaments && ms_tournaments && ms_rounds && ms_pools) {
          allow = true
        }
    }

    if (!allow) return <Segment basic>---</Segment>

    const tournament = tournaments[tournament_current]
    const { rounds } = tournament ?? {}
    const round = rounds && ms_rounds ? rounds[item_round] : null


    if (usePlayoffBrackets) {
      switch (tournamentType) {
        case tournamentTypes.existingPlayoff:
        case tournamentTypes.tournament:
          return playoffBrackets(round)
        default:
          return playoffTeamsSorted ? playoffBrackets(round) : <div className='hwcc'>Pending Seed Sorting</div>
      }
    } else {
      const { pools } = round ?? {}
      const pool = pools ? pools[item_pool] : null
      const { matches } = pool ?? {}
      const mss = <SeasonMatchesProvider
        tournamentType={tournamentType}
        poolMatches={matches}
        pools={pools}
        poolKey={item_pool}
        isTournament={true}
        viewItem={viewItem}
        handleMatchClick={handleMatchClick}
      >
        {!asGrid && <MatchListSelected key={uniqueKey('cts', 'mls')} />}
        {asGrid && <PlayoffBracket pool={pool} item_tournament={tournament_current} />}
      </SeasonMatchesProvider>
      return mss
    }
  }, [tournaments, tournament_current, item_round, ms_tournaments, ms_rounds])

  const menuSidebars = () => <MenuSidebars
    sidebarType={sidebarType}
    sidebar_items={sidebar_items}
    sidebar_handlers={sidebar_handlers}
    content={selectedMatches}
    dimmed={dimmed}
    inverted={inverted}
    key={uniqueKey('ms', 'cts')}
  />

  if (noData) {
    return <NoData fullCaption={'No Playoff Matches'} />
  } else {
    if (createScheduleType === createScheduleTypes.playoff) {
      return menuSidebars()
    } else {
      return menuSidebars()
    }
  }
}

export default CreateTournamentSchedule